(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-products-mto"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bundle-products-mto')) {
    class BundleProductsMto extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-add-all]');
        this.status = this.querySelector('[data-status]');
        this.querySelectorAll('select[data-variant]').forEach((select) => {
          select.addEventListener('change', () => this.updatePrice(select));
        });
        this.button?.addEventListener('click', () => this.addAll());
      }

      updatePrice(select) {
        const item = select.closest('[data-bundle-item]');
        const option = select.selectedOptions[0];
        if (!item || !option) return;
        item.querySelector('[data-price]').textContent = option.dataset.price;
        const compare = item.querySelector('[data-compare]');
        const onSale = Boolean(option.dataset.compare);
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !onSale;
        item.querySelector('[data-price-wrap]').classList.toggle('bpm-mto__price--sale', onSale);
      }

      async addAll() {
        const ids = [...this.querySelectorAll('[data-variant]')]
          .map((el) => Number(el.value))
          .filter(Boolean);
        if (!ids.length) return;
        this.button.setAttribute('aria-busy', 'true');
        this.setStatus('');
        try {
          const res = await fetch(`${this.dataset.addUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })) }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Error');
          if (this.dataset.afterAdd === 'cart') {
            window.location.href = this.dataset.cartUrl;
            return;
          }
          this.setStatus(this.button.dataset.success || '✓');
          window.location.reload();
        } catch (error) {
          this.setStatus(error.message, true);
          this.button.removeAttribute('aria-busy');
        }
      }

      setStatus(text, isError = false) {
        if (!this.status) return;
        this.status.textContent = text;
        this.status.classList.toggle('is-error', isError);
      }
    }
    customElements.define('bundle-products-mto', BundleProductsMto);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cookie-banner-mto')) {
    class CookieBannerMto extends HTMLElement {
      connectedCallback() {
        this.key = this.dataset.storageKey;
        this.card = this.querySelector('.cookie-mto__card');
        this.prefs = this.querySelector('[data-prefs]');
        this.overlay = document.querySelector('[data-cookie-overlay]');
        const designMode = window.Shopify?.designMode;

        let stored = null;
        try { stored = localStorage.getItem(this.key); } catch (e) {}
        if (stored && !designMode) return;

        this.hidden = false;
        this.querySelectorAll('[data-consent]').forEach((btn) =>
          btn.addEventListener('click', () => this.save(btn.dataset.consent))
        );
        this.querySelector('[data-open-prefs]')?.addEventListener('click', () => this.togglePrefs(true));
        this.querySelector('[data-close-prefs]')?.addEventListener('click', () => this.togglePrefs(false));
        this.overlay?.addEventListener('click', () => this.togglePrefs(false));
        this.watchStickyBar();
      }

      togglePrefs(open) {
        this.prefs.hidden = !open;
        this.card.hidden = open;
        if (this.overlay) this.overlay.hidden = !open;
        if (open) this.prefs.querySelector('input:not([disabled]), button')?.focus();
      }

      save(mode) {
        const consent = { analytics: false, marketing: false, preferences: false };
        if (mode === 'all') Object.keys(consent).forEach((k) => (consent[k] = true));
        if (mode === 'custom') {
          this.querySelectorAll('[data-consent-key]').forEach((input) => {
            consent[input.dataset.consentKey] = input.checked;
          });
        }
        try { localStorage.setItem(this.key, JSON.stringify(consent)); } catch (e) {}
        this.applyConsent(consent);
        this.togglePrefs(false);
        this.hidden = true;
      }

      // Seçimi Shopify'a yazar; analitik/pazarlama pikselleri bu izne göre çalışır
      applyConsent(consent) {
        const set = () => window.Shopify?.customerPrivacy?.setTrackingConsent?.(consent, () => {});
        if (window.Shopify?.customerPrivacy) return set();
        window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (!error) set();
        });
      }

      // Mobil ürün sayfası: yapışkan Sepete Ekle çubuğu görünürken banner onun üstüne çıkar
      watchStickyBar() {
        const bar = document.querySelector('[data-stuck]');
        if (!bar) return;
        const update = () => {
          const stuck = bar.getAttribute('data-stuck') === 'true';
          this.style.setProperty('--mto-sticky-atc-offset', stuck ? `${bar.offsetHeight}px` : '0px');
        };
        new MutationObserver(update).observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
        update();
      }
    }
    customElements.define('cookie-banner-mto', CookieBannerMto);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marka-kategori-vitrini-mto"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const dot = event.target.closest('[data-vitrini-dot]');
    if (!dot) return;

    const root = dot.closest('.marka-vitrini-mto');
    if (!root) return;

    root.querySelectorAll('[data-vitrini-dot], [data-vitrini-row]').forEach((el) => {
      el.classList.remove('is-active');
    });

    dot.classList.add('is-active');
    const target = root.querySelector(`#${CSS.escape(dot.dataset.vitriniTarget)}`);
    if (target) target.classList.add('is-active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marka-reels-mto"] && !Shopify.designMode) return;
  try {
    
  // Reels videoları ekrana girince oynar, çıkınca durur (sayfa açılışında video indirilmez)
  (() => {
    if (window.__reelsLazy) return;
    window.__reelsLazy = true;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting) {
            v.preload = 'auto';
            v.play().catch(() => {});
          } else {
            v.pause();
          }
        });
      },
      { rootMargin: '200px', threshold: 0.25 }
    );
    const scan = () => document.querySelectorAll('video[data-reel-autoplay]:not([data-reel-bound])').forEach((v) => {
      v.dataset.reelBound = '1';
      io.observe(v);
    });
    scan();
    document.addEventListener('DOMContentLoaded', scan);
    document.addEventListener('shopify:section:load', scan);
  })();

  // Reels: karta dokununca ekranı kaplayan pencerede, SESLİ ve kontrollü oynat.
  // Ses için oynatma dokunma/tıklama olayının içinde başlatılır (tarayıcılar kullanıcı hareketi olmadan sesli oynatmaz).
  (() => {
    if (window.__reelLightbox) return;
    window.__reelLightbox = true;

    let dlg, wrap, vid, userEl, capEl, closeBtn, lastOpener;

    const build = (closeLabel) => {
      if (dlg) return;
      dlg = document.createElement('dialog');
      dlg.className = 'mrr-lb';
      dlg.setAttribute('aria-label', closeLabel || 'Video');
      dlg.innerHTML =
        '<div class="mrr-lb__wrap">' +
        '<video class="mrr-lb__video" controls playsinline preload="auto"></video>' +
        '<p class="mrr-lb__meta"><span class="mrr-lb__user"></span><span class="mrr-lb__caption"></span></p>' +
        '<button type="button" class="mrr-lb__close">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button></div>';
      wrap = dlg.querySelector('.mrr-lb__wrap');
      vid = dlg.querySelector('video');
      userEl = dlg.querySelector('.mrr-lb__user');
      capEl = dlg.querySelector('.mrr-lb__caption');
      closeBtn = dlg.querySelector('.mrr-lb__close');
      closeBtn.setAttribute('aria-label', closeLabel || 'Close');
      closeBtn.addEventListener('click', () => dlg.close ? dlg.close() : cleanup());
      // Videonun dışına (koyu alana) dokunmak da kapatır
      dlg.addEventListener('click', (e) => {
        if (e.target === dlg) dlg.close ? dlg.close() : cleanup();
      });
      // Esc dahil her kapanışta temizle
      dlg.addEventListener('close', cleanup);
      dlg.addEventListener('cancel', () => {});
      document.body.appendChild(dlg);
    };

    const cleanup = () => {
      if (!vid) return;
      vid.pause();
      vid.removeAttribute('src');
      vid.removeAttribute('poster');
      vid.load();
      dlg.removeAttribute('open');
      document.documentElement.classList.remove('mrr-lb-open');
      // Kart videoları ekrandaysa tekrar oynasın
      document.querySelectorAll('video[data-reel-autoplay]').forEach((v) => {
        const r = v.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight && r.width > 0) v.play().catch(() => {});
      });
      if (lastOpener && lastOpener.isConnected) lastOpener.focus({ preventScroll: true });
    };

    const open = (btn) => {
      build(btn.dataset.reelCloseLabel);
      lastOpener = btn;
      const ratio = parseFloat(btn.dataset.reelRatio) || 0.5625;
      wrap.style.setProperty('--mrr-lb-ratio', String(ratio));
      userEl.textContent = btn.dataset.reelUser || '';
      capEl.textContent = btn.dataset.reelCaption || '';
      // Arka plandaki kart videolarını durdur (ses/performans)
      document.querySelectorAll('video[data-reel-autoplay]').forEach((v) => v.pause());
      vid.muted = false;
      vid.volume = 1;
      vid.loop = false;
      if (btn.dataset.reelPoster) vid.poster = btn.dataset.reelPoster;
      vid.src = btn.dataset.reelSrc;
      document.documentElement.classList.add('mrr-lb-open');
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
      const p = vid.play();
      if (p && p.catch) p.catch(() => { /* engellenirse kontrollerden oynat'a basılır */ });
      closeBtn.focus({ preventScroll: true });
    };

    document.addEventListener('click', (e) => {
      const btn = e.target.closest && e.target.closest('[data-reel-open]');
      if (!btn) return;
      e.preventDefault();
      open(btn);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-mto"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-tabs-mto')) {
    class ProductTabsMto extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('.product-tabs-mto__tab')];
        this.panels = [...this.querySelectorAll('.product-tabs-mto__panel')];
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.select(n);
            this.tabs[n].focus();
          });
        });
        this.prev?.addEventListener('click', () => this.scroll(-1));
        this.next?.addEventListener('click', () => this.scroll(1));
        this.panels.forEach((p) => this.bindTrack(p));
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.tabs.indexOf(e.target);
          if (i > -1) this.select(i);
        });
        this.updateArrows();
      }

      bindTrack(p) {
        p.querySelector('.product-tabs-mto__track')?.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      }

      // İlk sekme dışındaki paneller <template> içinde gelir; sekme seçilince bir kez bas (sayfa HTML'i küçülür)
      hydrate(p) {
        const tpl = p.querySelector('template[data-ptm-lazy]');
        if (!tpl) return;
        p.appendChild(tpl.content.cloneNode(true));
        tpl.remove();
        this.bindTrack(p);
      }

      get track() {
        const panel = this.panels.find((p) => !p.hidden) || this.panels[0];
        return panel?.querySelector('.product-tabs-mto__track');
      }

      select(i) {
        this.tabs.forEach((t, k) => {
          t.setAttribute('aria-selected', k === i ? 'true' : 'false');
          t.tabIndex = k === i ? 0 : -1;
        });
        this.panels.forEach((p, k) => (p.hidden = k !== i));
        this.hydrate(this.panels[i]);
        this.updateArrows();
      }

      scroll(dir) {
        const track = this.track;
        if (!track) return;
        const item = track.querySelector('.product-tabs-mto__item');
        const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }

      updateArrows() {
        const track = this.track;
        if (!track || !this.prev || !this.next) return;
        const max = track.scrollWidth - track.clientWidth - 2;
        this.prev.disabled = track.scrollLeft <= 2;
        this.next.disabled = track.scrollLeft >= max;
      }
    }
    customElements.define('product-tabs-mto', ProductTabsMto);
  }

  } catch(e) { console.error(e); }
})();
})();
